module.exports = __webpack_public_path__ + "../resources/img/ic_cancel.f9fc1934.svg";